var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:_vm.myClass,style:('max-height: '+ _vm.height + 'px; max-width: '+ _vm.width +'px'),attrs:{"src":_vm.url,"alt":_vm.alt}})
}
var staticRenderFns = []

export { render, staticRenderFns }